(function () {
  'use strict';
  document.documentElement.classList.add('js');

  /* ---------------------------------------------------------------------
     Store facts come from Liquid, in the [data-landing-data] blob that
     sections/landing.liquid emits: variant ids, prices in cents, stock, the
     money format and the discount code. Nothing about the catalogue is
     hardcoded here — change prices in Shopify and the promo code in the
     section's theme-editor settings.
  --------------------------------------------------------------------- */
  var DATA = (function () {
    var el = document.querySelector('[data-landing-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();

  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  // Shopify prices are integers in cents; money_format looks like "${{amount}}".
  var money = function (cents) {
    var fmt = (DATA && DATA.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  };
  // rAF never fires while the document is hidden; fall back to a timer so scroll-driven work still runs.
  var later = function (fn) { return document.hidden ? setTimeout(fn, 32) : requestAnimationFrame(fn); };

  /* ---------- the mascot: one generator for every snake on the page ---------- */
  var PAL = {
    green: { body: '#82BE3E', shade: '#5F9A2A', hub: '#98CC55', seg: ['#82BE3E', '#F1D9AE'] },
    beige: { body: '#EBC99B', shade: '#CFA86C', hub: '#E4BF8C', seg: ['#EBC99B', '#9CC85A'] }
  };
  function headSVG(hx, hy, P) {
    return '<rect x="' + hx + '" y="' + (hy + 8) + '" width="128" height="92" rx="40" fill="' + P.body + '"/>' +
      '<rect x="' + (hx + 20) + '" y="' + (hy + 70) + '" width="116" height="30" rx="14" fill="#FFF3DF"/>' +
      '<path d="M' + (hx + 128) + ' ' + (hy + 84) + ' l18 -4 -3 6 8 5 -23 2z" fill="#FF7A3D"/>' +
      '<ellipse cx="' + (hx + 62) + '" cy="' + (hy + 18) + '" rx="27" ry="24" fill="#fff" stroke="' + P.shade + '" stroke-width="3"/>' +
      '<ellipse cx="' + (hx + 100) + '" cy="' + (hy + 18) + '" rx="27" ry="24" fill="#fff" stroke="' + P.shade + '" stroke-width="3"/>' +
      '<circle cx="' + (hx + 67) + '" cy="' + (hy + 22) + '" r="9" fill="#141414"/><circle cx="' + (hx + 105) + '" cy="' + (hy + 22) + '" r="9" fill="#141414"/>' +
      '<circle cx="' + (hx + 70) + '" cy="' + (hy + 19) + '" r="3" fill="#fff"/><circle cx="' + (hx + 108) + '" cy="' + (hy + 19) + '" r="3" fill="#fff"/>' +
      '<circle cx="' + (hx + 16) + '" cy="' + (hy + 58) + '" r="15" fill="' + P.hub + '" stroke="' + P.shade + '" stroke-width="3"/>' +
      '<rect x="' + (hx + 12) + '" y="' + (hy + 50) + '" width="8" height="16" rx="3" fill="#FFB421"/>' +
      '<circle cx="' + (hx + 112) + '" cy="' + (hy + 50) + '" r="2.5" fill="' + P.shade + '"/><circle cx="' + (hx + 121) + '" cy="' + (hy + 53) + '" r="2.5" fill="' + P.shade + '"/>';
  }
  function snake(o) {
    o = o || {};
    var P = PAL[o.color || 'green'], segs = o.segs == null ? 4 : o.segs, x = 8, y = 76, parts = [];
    for (var i = 0; i < segs; i++) {
      var w = Math.sin(i * 1.3) * 6, c = P.seg[i % 2];
      parts.push('<rect x="' + x + '" y="' + (y + w) + '" width="46" height="52" rx="16" fill="' + c + '"/>' +
        '<path d="M' + (x + 10) + ' ' + (y + w + 15) + 'q6 -6 12 0 M' + (x + 24) + ' ' + (y + w + 15) + 'q6 -6 12 0 M' + (x + 17) + ' ' + (y + w + 27) + 'q6 -6 12 0" stroke="rgba(0,0,0,.18)" stroke-width="2.5" fill="none" stroke-linecap="round"/>' +
        '<circle cx="' + (x + 43) + '" cy="' + (y + w + 26) + '" r="3" fill="#C9CCD1"/>');
      x += 52;
    }
    var hx = x - 6, hy = 38;
    parts.push(headSVG(hx, hy, P));
    var W = hx + 150, H = 150, inner = parts.join('');
    if (o.facing === 'left') inner = '<g transform="translate(' + W + ' 0) scale(-1 1)">' + inner + '</g>';
    var vb = o.headOnly ? '0 40 152 105' : '0 30 ' + W + ' ' + (H - 20);
    return '<svg viewBox="' + vb + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + (o.color || 'green') + ' Nibbles snake">' + inner + '</svg>';
  }
  function beanSVG(color, extra) {
    var f = color === 'green' ? '#9CC85A' : '#F1D9AE', s = color === 'green' ? '#5F9A2A' : '#D9B87F';
    return '<svg viewBox="0 0 48 40" class="bean-svg" ' + (extra || '') + ' aria-hidden="true"><rect x="2" y="4" width="44" height="34" rx="14" fill="' + f + '" stroke="' + s + '" stroke-width="2.5"/><path d="M12 15q6-6 12 0M24 15q6-6 12 0M18 25q6-6 12 0" stroke="rgba(0,0,0,.18)" stroke-width="2.5" fill="none" stroke-linecap="round"/><circle cx="41" cy="22" r="3" fill="#C9CCD1"/></svg>';
  }
  function beanG(color, x, y, scale) {
    var f = color === 'green' ? '#9CC85A' : '#F1D9AE', s = color === 'green' ? '#5F9A2A' : '#D9B87F';
    return '<g transform="translate(' + x + ' ' + y + ') scale(' + (scale || 1) + ') translate(-24 -20)"><rect x="2" y="4" width="44" height="34" rx="14" fill="' + f + '" stroke="' + s + '" stroke-width="2.5"/><path d="M12 15q6-6 12 0M24 15q6-6 12 0M18 25q6-6 12 0" stroke="rgba(0,0,0,.18)" stroke-width="2.5" fill="none" stroke-linecap="round"/><circle cx="41" cy="22" r="3" fill="#C9CCD1"/></g>';
  }
  function remoteSVG(cls) {
    return '<svg viewBox="0 0 220 130" class="' + (cls || 'remote') + '" aria-hidden="true">' +
      '<rect x="6" y="14" width="208" height="104" rx="34" fill="#F1E7D6" stroke="#13201A" stroke-width="3"/>' +
      '<rect x="6" y="14" width="208" height="104" rx="34" fill="none" stroke="#D9CDAE" stroke-width="1" transform="translate(0 6)" opacity=".7"/>' +
      '<rect x="34" y="28" width="34" height="74" rx="17" fill="#E7DCC8"/><rect x="40" y="34" width="22" height="28" rx="9" fill="#FFB421"/><rect x="40" y="68" width="22" height="28" rx="9" fill="#FFB421"/>' +
      '<path d="M51 42l-5 6h10zM51 88l5-6H46z" fill="#7A4A00"/>' +
      '<rect x="130" y="48" width="74" height="34" rx="17" fill="#E7DCC8"/><rect x="136" y="54" width="28" height="22" rx="9" fill="#FFB421"/><rect x="170" y="54" width="28" height="22" rx="9" fill="#FFB421"/>' +
      '<path d="M144 65l6-5v10zM190 65l-6-5v10z" fill="#7A4A00"/>' +
      '<circle cx="106" cy="54" r="5" fill="#FF6A3D"/><rect x="99" y="66" width="14" height="10" rx="4" fill="#82BE3E"/><rect x="96" y="82" width="20" height="8" rx="4" fill="#9CC85A" stroke="#5F9A2A" stroke-width="1.5"/></svg>';
  }
  function phoneSVG() {
    // a pixel snake on a tiny screen: the game as most people remember it
    var px = '', cells = [[3,6],[4,6],[5,6],[6,6],[6,5],[6,4],[6,3],[7,3],[8,3]];
    cells.forEach(function (c) { px += '<rect x="' + (18 + c[0] * 9) + '" y="' + (44 + c[1] * 9) + '" width="8" height="8" rx="1.5" fill="#82BE3E"/>'; });
    px += '<rect x="' + (18 + 10 * 9) + '" y="' + (44 + 3 * 9) + '" width="8" height="8" rx="4" fill="#FFB421"/>';
    return '<svg viewBox="0 0 120 200" class="phone" aria-hidden="true"><rect x="8" y="4" width="104" height="192" rx="20" fill="#13201A"/><rect x="16" y="24" width="88" height="152" rx="10" fill="#1F2F26"/><rect x="44" y="12" width="32" height="5" rx="2.5" fill="#3A4A40"/>' + px + '</svg>';
  }
  function motionLines(x, y) {
    return '<g stroke="#13201A" stroke-width="4" stroke-linecap="round" opacity=".55"><path d="M' + x + ' ' + y + 'h26"/><path d="M' + (x - 8) + ' ' + (y + 16) + 'h22"/><path d="M' + (x + 4) + ' ' + (y + 32) + 'h18"/></g>';
  }

  // Fill every [data-art] / [data-bean] placeholder
  var ART = {
    'remote': function () { return '<svg viewBox="0 0 340 200" aria-hidden="true"><g transform="translate(20 40) rotate(-6)">' + remoteSVG().replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g><g transform="translate(200 78) scale(.62)">' + headSVG(0, 0, PAL.green) + '</g></svg>'; },
    'chase': function () { return '<svg viewBox="0 0 420 200" aria-hidden="true">' + motionLines(6, 88) + '<g transform="translate(30 30) scale(.62)">' + snake({ segs: 3 }).replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g>' + beanG('beige', 330, 92, 1.1) + beanG('green', 385, 60, .9) + beanG('beige', 392, 140, .9) + '</svg>'; },
    'duel': function () { return '<svg viewBox="0 0 420 200" aria-hidden="true"><g transform="translate(-10 40) scale(.6)">' + snake({ segs: 2 }).replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g>' + beanG('beige', 210, 118, 1.15) + '<g transform="translate(430 40) scale(-.6 .6)">' + snake({ segs: 2, color: 'beige' }).replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g><text x="210" y="60" text-anchor="middle" font-family="Silkscreen,monospace" font-size="18" fill="#FF6A3D">!</text></svg>'; },
    'phone': function () { return phoneSVG(); },
    'escape': function () { return snake({ segs: 4 }); },
    'remote-tilt': function () { return remoteSVG('remote'); },
    'duel-wide': function () { return '<div class="duel">' + snake({ segs: 2 }) + beanSVG('beige') + snake({ segs: 2, color: 'beige', facing: 'left' }) + '</div>'; },
    'swap': function () { return '<div class="swap">' + phoneSVG() + '<svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg><div class="snk">' + snake({ segs: 3 }) + '</div></div>'; },
    'snake-big': function () { return snake({ segs: 6, facing: 'left' }); },
    'snake-left': function () { return snake({ segs: 3 }); },
    'snake-right': function () { return snake({ segs: 3, color: 'beige', facing: 'left' }); }
  };
  $$('[data-art]').forEach(function (el) { var f = ART[el.getAttribute('data-art')]; if (f) el.innerHTML = f(); });
  $$('span[data-bean]').forEach(function (el) { el.innerHTML = beanSVG(el.getAttribute('data-bean')); });
  $$('g[data-bean]').forEach(function (g) { g.innerHTML = beanG(g.getAttribute('data-bean'), 0, 0, .8); });

  /* ---------- nav ---------- */
  var nav = $('#nav'), burger = $('#burger'), menu = $('#menu');
  function onScrollNav() { nav.classList.toggle('scrolled', window.scrollY > 8); }
  function openMenu(open) {
    menu.classList.toggle('open', open); menu.setAttribute('aria-hidden', String(!open));
    burger.setAttribute('aria-expanded', String(open)); document.body.classList.toggle('locked', open);
    if (open) $('#menuClose').focus(); else burger.focus();
  }
  burger.addEventListener('click', function () { openMenu(true); });
  $('#menuClose').addEventListener('click', function () { openMenu(false); });
  $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { openMenu(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('open')) openMenu(false); });

  /* ---------- buy box -----------------------------------------------------
     Server-rendered by sections/landing.liquid, so it is already correct before
     this runs; everything below is the live switching on top of it.
  ----------------------------------------------------------------------- */
  var buy = (function () {
    var form = $('[data-buy-form]');
    if (!form || !DATA) return null;

    var packI = DATA.packIndex, colorI = DATA.colorIndex;
    var variants = DATA.variants || [];
    var packs = DATA.packs || {};
    var maxQty = Math.max(1, DATA.maxQty || 5);

    // One colour = one variant now: the colour picker is the whole chooser and
    // the pack (single vs double) is derived from whichever variant it lands on.
    var options = $$('[data-color-value]', form);
    var tiers = $$('[data-pack-pick]', form);
    var idInput = $('[data-variant-id]', form), qtyInput = $('[data-qty-input]', form);
    var addBtn = $('[data-add]', form), addLabel = $('[data-add-label]', form);

    var packOf = function (v) { return packI >= 0 && v ? v.options[packI] : null; };
    var colorOf = function (v) { return colorI >= 0 && v ? v.options[colorI] : null; };
    var checked = function (els) {
      for (var i = 0; i < els.length; i++) if (els[i].getAttribute('aria-checked') === 'true') return els[i];
      return els[0] || null;
    };
    var attr = function (el, name) { return el ? el.getAttribute(name) : null; };

    var state = {
      color: attr(checked(options), 'data-color-value'),
      qty: 1
    };

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (colorOf(variants[i]) === state.color) return variants[i];
      }
      return variants[0] || null;
    }
    // Map a pack to a colour: keep the current colour when it exists in that pack,
    // otherwise fall back to the pack's first colour. Used by the pack tiles and
    // the comparison-card [data-pick] deep links.
    function colorForPack(pack) {
      var first = null;
      for (var i = 0; i < variants.length; i++) {
        if (packOf(variants[i]) !== pack) continue;
        if (first === null) first = colorOf(variants[i]);
        if (colorOf(variants[i]) === state.color) return state.color;
      }
      return first !== null ? first : state.color;
    }

    function render() {
      var v = findVariant();
      if (!v) return;
      var pk = packOf(v);
      var total = v.price * state.qty;
      var pack = packs[pk] || {};

      idInput.value = v.id;
      qtyInput.value = state.qty;

      options.forEach(function (o) {
        o.setAttribute('aria-checked', String(o.getAttribute('data-color-value') === state.color));
      });
      tiers.forEach(function (t) {
        t.setAttribute('aria-checked', String(t.getAttribute('data-pack-value') === pk));
      });

      var hint = $('[data-color-hint]', form);
      if (hint) hint.textContent = state.color || '';
      var lock = $('[data-lock-note]', form);
      if (lock) {
        var note = pack.colorNote || '';
        lock.textContent = note;
        lock.hidden = note === '';
      }

      var out = $('[data-qty-out]', form);
      if (out) out.textContent = state.qty;

      var totalEl = $('[data-total]', form);
      if (totalEl) totalEl.textContent = money(total);
      if (addLabel) addLabel.textContent = v.available ? 'Add to cart · ' + money(total) : 'Sold out';
      if (addBtn) addBtn.disabled = !v.available;

      var inc = $('[data-included]');
      if (inc && pack.included) inc.textContent = pack.included;

      var sName = $('[data-sticky-name]');
      if (sName) {
        sName.textContent = (v.title || pk) + (state.qty > 1 ? ' × ' + state.qty : '') + ' · ' + money(total);
      }

      // The gallery follows the choice, when a photo is tagged for it.
      if (gallery) gallery.showFor(pk, state.color);
      return v;
    }

    options.forEach(function (o) {
      o.addEventListener('click', function () { state.color = o.getAttribute('data-color-value'); render(); });
    });
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { state.color = colorForPack(t.getAttribute('data-pack-value')); render(); });
    });
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = Math.min(maxQty, Math.max(1, state.qty + (parseInt(b.getAttribute('data-qty'), 10) || 0)));
        render();
      });
    });
    $$('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.color = colorForPack(b.getAttribute('data-pick'));
        render();
        if (b.tagName === 'BUTTON') location.hash = '#buy';
      });
    });

    /* --- add to cart ------------------------------------------------------
       Progressive enhancement: without JS the form posts to /cart/add and
       return_to carries the customer through the discount route. With JS we
       add in the background and keep them on the page.
    --------------------------------------------------------------------- */
    var notice = null;
    function say(html) {
      if (!notice) {
        notice = document.createElement('p');
        notice.className = 'promo';
        notice.setAttribute('role', 'status');
        notice.style.marginTop = '14px';
        form.parentNode.insertBefore(notice, form.nextSibling);
      }
      notice.innerHTML = html;
      notice.hidden = false;
    }

    var busy = false;
    form.addEventListener('submit', function (e) {
      if (busy || !window.fetch || !DATA.cartAddUrl) return;      // let it post normally
      e.preventDefault();
      busy = true;
      var restore = addLabel ? addLabel.textContent : '';
      if (addLabel) addLabel.textContent = 'Adding…';

      fetch(DATA.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: state.qty }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || 'add failed');
          // Applying the discount is a cookie the discount route sets; if this
          // request fails the code is still shown on the page to type in.
          var after = DATA.promo
            ? fetch('/discount/' + encodeURIComponent(DATA.promo), { credentials: 'same-origin' }).catch(function () {})
            : Promise.resolve();
          return after.then(function () {
            say('<code>Added</code><span>' + (DATA.promo ? 'Enter ' + DATA.promo + ' at checkout. ' : '') +
                '<a href="' + (DATA.cartUrl || '/cart') + '" style="text-decoration:underline">Go to cart</a></span>');
            if (addLabel) addLabel.textContent = restore;
            busy = false;
          });
        })
        .catch(function () {
          // Fall back to the plain form post, which cannot silently fail.
          busy = false;
          if (addLabel) addLabel.textContent = restore;
          form.submit();
        });
    });

    render();
    return { render: render };
  })();

  /* ---------- gallery ---------- */
  var gallery = (function () {
    var track = $('#galleryTrack'), thumbs = $('#galleryThumbs'), figs = $$('figure', track), cur = 0, btns = [];
    if (!track) return null;
    figs.forEach(function (f, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Photo ' + (i + 1));
      var im = f.querySelector('img'); b.innerHTML = '<img src="' + im.getAttribute('src') + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { go(i); });
      thumbs.appendChild(b); btns.push(b);
    });
    function mark(i) { cur = i; btns.forEach(function (b, j) { b.classList.toggle('on', j === i); b.setAttribute('aria-selected', String(j === i)); }); }
    function go(i, quiet) { mark(i); track.scrollTo({ left: track.clientWidth * i, behavior: (RM || quiet) ? 'auto' : 'smooth' }); }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 80); }, { passive: true });
    // A figure can name the selection it illustrates, via data-for-pack /
    // data-for-color in the section markup.
    function showFor(pack, color) {
      for (var i = 0; i < figs.length; i++) {
        var fp = figs[i].getAttribute('data-for-pack');
        if (!fp || fp !== pack) continue;
        var fc = figs[i].getAttribute('data-for-color');
        if (fc && color && fc !== color) continue;
        go(i, true);
        return;
      }
    }
    mark(0);
    return { go: go, showFor: showFor };
  })();
  // Second pass now that the gallery exists — the first ran inside the IIFE,
  // before `gallery` was assigned.
  if (buy) buy.render();

  /* ---------- sticky bar (mobile) ---------- */
  var sticky = $('#stickybar'), hero = $('#top'), buy = $('#buy'), footer = $('.footer');
  function stickyCheck() {
    var h = hero.getBoundingClientRect(), b = buy.getBoundingClientRect(), f = footer.getBoundingClientRect(), vh = innerHeight;
    var show = h.bottom < 0 && !(b.top < vh * .8 && b.bottom > vh * .3) && f.top > vh;
    sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
  }

  /* ---------- scroll trail ---------- */
  var trail = (function () {
    var box = $('#trail'), path = $('#trailPath'), eaten = $('#trailEaten'), beans = $('#trailBeans'), head = $('#trailHead');
    if (!box || !path.getTotalLength) return null;
    var L = path.getTotalLength(), T = [.14, .3, .46, .62, .78, .92], nodes = [];
    eaten.style.strokeDasharray = L; eaten.style.strokeDashoffset = L;
    T.forEach(function (t, i) {
      var p = path.getPointAtLength(L * t), g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('class', 'tb'); g.innerHTML = beanG(i % 2 ? 'green' : 'beige', p.x, p.y, .95); beans.appendChild(g); nodes.push(g);
    });
    head.innerHTML = '<g id="trailHeadIn">' + headSVG(0, 0, PAL.green) + '</g>';
    var inner = $('#trailHeadIn'), lastP = -1;
    function place(prog) {
      var d = L * prog, p = path.getPointAtLength(d), q = path.getPointAtLength(Math.min(L, d + 6));
      var a = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI, flip = Math.abs(a) > 90;
      inner.setAttribute('transform', 'translate(' + p.x + ' ' + p.y + ') rotate(' + a + ') ' + (flip ? 'scale(.5 -.5)' : 'scale(.5)') + ' translate(-70 -52)');
      eaten.style.strokeDashoffset = L * (1 - prog);
      nodes.forEach(function (g, i) { g.classList.toggle('eaten', prog > T[i] + .02); });
    }
    function update() {
      var r = box.getBoundingClientRect(), vh = innerHeight;
      // A zero-height viewport (hidden pane, thumbnail capture) makes the
      // divisor 0 and prog NaN, which getPointAtLength rejects outright.
      if (!vh || r.bottom < -200 || r.top > vh + 200) return;
      var prog = Math.max(0, Math.min(1, (vh - r.top) / (vh * .5 + r.height)));
      if (RM) prog = 1;
      if (!isFinite(prog)) return;
      if (Math.abs(prog - lastP) < .002) return; lastP = prog; place(prog);
    }
    place(RM ? 1 : 0);
    return { update: update };
  })();

  /* ---------- scroll plumbing ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    // `finally`, so one throwing tick can't leave `ticking` stuck true and
    // silently kill the nav, sticky bar and trail for the rest of the session.
    later(function () {
      try { onScrollNav(); stickyCheck(); if (trail) trail.update(); }
      finally { ticking = false; }
    });
  }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  onScroll();

  /* ---------- reveal + counters ---------- */
  var revealEls = $$('[data-reveal]');
  function revealAll() { revealEls.forEach(function (e) { e.classList.add('in'); }); }
  if ('IntersectionObserver' in window && !RM) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    revealEls.forEach(function (e) { io.observe(e); });
    setTimeout(revealAll, 2500); // belt and braces: nothing stays shifted
  } else revealAll();

  function countUp(el) {
    var end = parseInt(el.getAttribute('data-count'), 10), t0 = null, dur = 900;
    if (RM) { el.textContent = end; return; }
    (function f(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(end * e); if (k < 1) later(function () { f(performance.now()); }); })(performance.now());
  }
  var counters = $$('[data-count]');
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } }); }, { threshold: .5 });
    counters.forEach(function (c) { cio.observe(c); });
    setTimeout(function () { counters.forEach(function (c) { if (c.textContent === '0') countUp(c); }); }, 4000);
  } else counters.forEach(countUp);

  /* ---------- FAQ ---------- */
  $$('.qa').forEach(function (qa) {
    var btn = $('.qa__btn', qa);
    btn.addEventListener('click', function () {
      var open = !qa.classList.contains('open');
      qa.classList.toggle('open', open); btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------- the demo: Nibbles on a screen, for once ---------- */
  (function () {
    var canvas = $('#game'), arena = $('#arena');
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d'), W = 0, H = 0, dpr = 1, running = false, over = false, started = false, last = 0, pattern = null;
    var overlay = $('#overlay'), oTitle = $('#overlayTitle'), oText = $('#overlayText'), playBtn = $('#playBtn'), hudP1 = $('#hudP1'), hudP2 = $('#hudP2');
    var beans = [], snakes = [], pops = [], SEG = 22, MAXB = 12;
    var GREEN = { body: '#82BE3E', shade: '#5F9A2A', alt: '#F1D9AE', hub: '#98CC55' }, BEIGE = { body: '#EBC99B', shade: '#CFA86C', alt: '#9CC85A', hub: '#E4BF8C' };

    function resize() {
      var r = arena.getBoundingClientRect(); dpr = Math.min(devicePixelRatio || 1, 2); W = r.width; H = r.height;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var pc = document.createElement('canvas'); pc.width = pc.height = 28; var p = pc.getContext('2d');
      p.fillStyle = '#F7E9CE'; p.fillRect(0, 0, 28, 28); p.fillStyle = 'rgba(19,32,26,.10)'; p.beginPath(); p.arc(14, 14, 1.6, 0, 7); p.fill();
      pattern = ctx.createPattern(pc, 'repeat');
      if (!running) draw();
    }
    function rr(x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }
    function mk(x, y, a, pal, ai) { return { x: x, y: y, a: a, pal: pal, ai: ai, speed: 112, turn: 0, hist: [], len: 0, chomp: 0, cool: 0, think: 0, target: null, segs: [] }; }
    function spawn(n, near) {
      for (var i = 0; i < n; i++) {
        var x = near ? near.x + (Math.random() - .5) * 90 : 40 + Math.random() * (W - 80), y = near ? near.y + (Math.random() - .5) * 90 : 40 + Math.random() * (H - 80);
        beans.push({ x: Math.max(30, Math.min(W - 30, x)), y: Math.max(30, Math.min(H - 30, y)), c: beans.length % 2, ph: Math.random() * 6 });
      }
    }
    function reset() {
      beans.length = 0; pops.length = 0; snakes.length = 0;
      snakes.push(mk(W * .25, H * .5, 0, GREEN, false), mk(W * .75, H * .5, Math.PI, BEIGE, true));
      spawn(MAXB); over = false; score();
    }
    function score() { hudP1.textContent = snakes[0].len; hudP2.textContent = snakes[1].len; }
    function pop(x, y, t, c) { pops.push({ x: x, y: y, t: t, c: c || '#13201A', life: 1 }); }
    function segsOf(s) {
      var out = [], h = s.hist, acc = 0, need = SEG;
      for (var i = 1; i < h.length && out.length < s.len; i++) {
        var d = Math.hypot(h[i].x - h[i - 1].x, h[i].y - h[i - 1].y); acc += d;
        while (acc >= need && out.length < s.len) { var k = 1 - (acc - need) / (d || 1); out.push({ x: h[i - 1].x + (h[i].x - h[i - 1].x) * k, y: h[i - 1].y + (h[i].y - h[i - 1].y) * k, a: Math.atan2(h[i - 1].y - h[i].y, h[i - 1].x - h[i].x) }); need += SEG; }
      }
      return out;
    }
    function step(dt) {
      snakes.forEach(function (s, si) {
        if (s.ai) {
          s.think -= dt;
          if (s.think <= 0 || !s.target || beans.indexOf(s.target) < 0) {
            var best = null, bd = 1e12; beans.forEach(function (b) { var d = (b.x - s.x) * (b.x - s.x) + (b.y - s.y) * (b.y - s.y); if (d < bd) { bd = d; best = b; } });
            s.target = best; s.think = .35 + Math.random() * .3;
          }
          if (s.target) { var want = Math.atan2(s.target.y - s.y, s.target.x - s.x), diff = Math.atan2(Math.sin(want - s.a), Math.cos(want - s.a)); s.turn = Math.max(-1, Math.min(1, diff * 1.6)) + (Math.random() - .5) * .5; }
        }
        s.a += s.turn * 2.7 * dt;
        s.x += Math.cos(s.a) * s.speed * dt; s.y += Math.sin(s.a) * s.speed * dt;
        var m = 24;
        if (s.x < m) { s.x = m; s.a = Math.PI - s.a; } if (s.x > W - m) { s.x = W - m; s.a = Math.PI - s.a; }
        if (s.y < m) { s.y = m; s.a = -s.a; } if (s.y > H - m) { s.y = H - m; s.a = -s.a; }
        var h = s.hist; if (!h.length || Math.hypot(s.x - h[0].x, s.y - h[0].y) >= 3) { h.unshift({ x: s.x, y: s.y }); if (h.length > 600) h.length = 600; }
        for (var i = beans.length - 1; i >= 0; i--) { var b = beans[i]; if (Math.hypot(b.x - s.x, b.y - s.y) < 24) { beans.splice(i, 1); s.len++; s.chomp = 1; pop(s.x, s.y - 26, 'CHOMP', s.pal.shade); if (s.ai && s.target === b) s.target = null; } }
        s.chomp = Math.max(0, s.chomp - dt * 2.5); s.cool = Math.max(0, s.cool - dt);
        s.segs = segsOf(s);
        // clip your own tail: drop two beans, exactly like the real thing
        if (!s.cool && s.len > 3) {
          for (var j = 3; j < s.segs.length; j++) { if (Math.hypot(s.segs[j].x - s.x, s.segs[j].y - s.y) < 14) { var tail = s.segs[s.segs.length - 1]; s.len = Math.max(0, s.len - 2); spawn(2, tail); s.cool = 1.4; pop(s.x, s.y - 26, 'OOPS', '#FF6A3D'); break; } }
        }
      });
      for (var p = pops.length - 1; p >= 0; p--) { pops[p].life -= dt * 1.2; pops[p].y -= dt * 18; if (pops[p].life <= 0) pops.splice(p, 1); }
      score();
      if (!beans.length && !over) { over = true; running = false; end(); }
    }
    function drawBean(b, t) {
      ctx.save(); ctx.translate(b.x, b.y + Math.sin(t * 3 + b.ph) * 1.5);
      ctx.fillStyle = b.c ? '#9CC85A' : '#F1D9AE'; ctx.strokeStyle = b.c ? '#5F9A2A' : '#D9B87F'; ctx.lineWidth = 2;
      rr(-14, -11, 28, 22, 9); ctx.fill(); ctx.stroke();
      ctx.fillStyle = '#C9CCD1'; ctx.beginPath(); ctx.arc(10, 1, 2, 0, 7); ctx.fill(); ctx.restore();
    }
    function drawSnake(s) {
      for (var i = s.segs.length - 1; i >= 0; i--) {
        var g = s.segs[i]; ctx.save(); ctx.translate(g.x, g.y); ctx.rotate(g.a);
        ctx.fillStyle = i % 2 ? s.pal.alt : s.pal.body; rr(-12, -10, 24, 20, 8); ctx.fill();
        ctx.strokeStyle = 'rgba(0,0,0,.15)'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(-6, -3); ctx.quadraticCurveTo(-2, -8, 2, -3); ctx.moveTo(-2, 4); ctx.quadraticCurveTo(2, -1, 6, 4); ctx.stroke(); ctx.restore();
      }
      ctx.save(); ctx.translate(s.x, s.y); ctx.rotate(s.a); var k = 1 + s.chomp * .18; ctx.scale(k, k);
      ctx.fillStyle = '#FFF3DF'; rr(-8, -13, 30, 26, 10); ctx.fill();               // jaw
      ctx.fillStyle = s.pal.body; rr(-18, -16, 40, 30 - s.chomp * 6, 14); ctx.fill(); // head, lifts when chomping
      ctx.fillStyle = s.pal.hub; ctx.beginPath(); ctx.arc(-12, 0, 6, 0, 7); ctx.fill(); ctx.fillStyle = '#FFB421'; rr(-14, -3, 4, 6, 1.5); ctx.fill();
      ctx.strokeStyle = '#FF7A3D'; ctx.lineWidth = 3; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(22, 2); ctx.lineTo(32, 2); ctx.lineTo(36, -1); ctx.moveTo(32, 2); ctx.lineTo(36, 5); ctx.stroke();
      ctx.fillStyle = '#fff'; ctx.strokeStyle = s.pal.shade; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.arc(4, -9, 7, 0, 7); ctx.fill(); ctx.stroke(); ctx.beginPath(); ctx.arc(4, 9, 7, 0, 7); ctx.fill(); ctx.stroke();
      ctx.fillStyle = '#141414'; ctx.beginPath(); ctx.arc(6, -9, 3.2, 0, 7); ctx.fill(); ctx.beginPath(); ctx.arc(6, 9, 3.2, 0, 7); ctx.fill();
      ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(7, -10, 1.1, 0, 7); ctx.fill(); ctx.beginPath(); ctx.arc(7, 8, 1.1, 0, 7); ctx.fill();
      ctx.restore();
    }
    function draw() {
      var t = performance.now() / 1000;
      ctx.fillStyle = pattern || '#F7E9CE'; ctx.fillRect(0, 0, W, H);
      beans.forEach(function (b) { drawBean(b, t); });
      snakes.forEach(drawSnake);
      ctx.font = '700 13px Silkscreen, monospace'; ctx.textAlign = 'center';
      pops.forEach(function (p) { ctx.globalAlpha = Math.max(0, p.life); ctx.fillStyle = p.c; ctx.fillText(p.t, p.x, p.y); });
      ctx.globalAlpha = 1;
    }
    function frame(t) {
      if (!running) return;
      var dt = Math.min(.05, (t - last) / 1000) || .016; last = t;
      step(dt); draw(); later(function () { frame(performance.now()); });
    }
    function play() {
      if (over) reset();
      overlay.hidden = true; running = true; started = true; last = performance.now();
      canvas.focus({ preventScroll: true }); later(function () { frame(performance.now()); });
    }
    function pause(msg) { if (!running) return; running = false; oTitle.textContent = 'Paused.'; oText.textContent = msg || 'The snakes are waiting.'; playBtn.setAttribute('aria-label', 'Resume'); overlay.hidden = false; }
    function end() {
      var a = snakes[0].len, b = snakes[1].len;
      oTitle.textContent = a > b ? 'Green wins ' + a + '–' + b + '.' : a < b ? 'Beige wins ' + b + '–' + a + '.' : 'A draw, ' + a + '–' + b + '.';
      oText.textContent = a > b ? 'Beige is already asking for the rematch.' : a < b ? 'Loser asks for the rematch. Go on.' : 'Nobody is accepting that. Again.';
      playBtn.setAttribute('aria-label', 'Rematch'); overlay.hidden = false;
    }
    playBtn.addEventListener('click', play);
    $('#rematchLink').addEventListener('click', function () { setTimeout(function () { if (!running) play(); }, 600); });
    // keyboard: only while the canvas has focus, so arrows never hijack page scrolling
    var keys = { ArrowLeft: -1, a: -1, A: -1, ArrowRight: 1, d: 1, D: 1 };
    canvas.addEventListener('keydown', function (e) { if (e.key in keys) { snakes[0].turn = keys[e.key]; e.preventDefault(); } else if (e.key === ' ' || e.key === 'Enter') { if (!running) play(); e.preventDefault(); } });
    canvas.addEventListener('keyup', function (e) { if (e.key in keys && snakes[0].turn === keys[e.key]) snakes[0].turn = 0; });
    function hold(btn, dir) {
      var on = function (e) { e.preventDefault(); snakes[0].turn = dir; btn.classList.add('down'); if (!running && started && !over) play(); };
      var off = function () { if (snakes[0].turn === dir) snakes[0].turn = 0; btn.classList.remove('down'); };
      btn.addEventListener('pointerdown', on); btn.addEventListener('pointerup', off); btn.addEventListener('pointercancel', off); btn.addEventListener('pointerleave', off);
    }
    hold($('#padL'), -1); hold($('#padR'), 1);
    // tap-to-steer: left half turns left, right half turns right
    canvas.addEventListener('pointerdown', function (e) { if (!running) return; var r = canvas.getBoundingClientRect(); snakes[0].turn = (e.clientX - r.left) < r.width / 2 ? -1 : 1; canvas.setPointerCapture(e.pointerId); });
    canvas.addEventListener('pointerup', function () { snakes[0].turn = 0; });
    canvas.addEventListener('pointercancel', function () { snakes[0].turn = 0; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting && running) pause('You scrolled away. The snakes noticed.'); }); }, { threshold: .15 }).observe(arena);
    document.addEventListener('visibilitychange', function () { if (document.hidden && running) pause(); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { resize(); if (!started) reset(); if (!running) draw(); }).observe(arena); else { addEventListener('resize', resize); }
    resize(); reset(); draw();
  })();
})();
